import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Ch1Hero } from "../components/editorial/Ch1Hero";
import { InsideCarousel } from "../components/editorial/InsideCarousel";
import { Ch2 } from "../components/editorial/Ch2";
import { Experience } from "../components/editorial/Experience";
import { Ch4Community } from "../components/editorial/Ch4Community";
import { Ch5Posts } from "../components/editorial/Ch5Posts";
import { HeardPlus } from "../components/editorial/HeardPlus";
import { Ch6Privacy } from "../components/editorial/Ch6Privacy";
import { TrustStrip } from "../components/editorial/TrustStrip";
import { Ch7Founder } from "../components/editorial/Ch7Founder";
import { FoundingMember } from "../components/editorial/FoundingMember";
import { Ch8Final } from "../components/editorial/Ch8Final";

export default function Landing() {
  return (
    <div className="bg-cream">
      <Navbar />
      <main>
        <Ch1Hero />
        <InsideCarousel />
        <Ch2 />
        <Experience />
        <Ch4Community />
        <Ch5Posts />
        <Ch6Privacy />
        <HeardPlus />
        <Ch7Founder />
        <FoundingMember />
        <TrustStrip />
        <Ch8Final />
      </main>
      <Footer />
    </div>
  );
}
